import { c as _c } from "react/compiler-runtime";
import { Home, S3_BUCKET_URL, StoreThemeEnum, defaultDesignValues, useDesignContext } from '@systemeio/digital-store-shared';
import { StoreFontPicker } from 'modules/stores/store/components/design/store-font-picker';
import ItemSteps from 'modules/stores/store/components/item-steps';
import { STORE_ITEM_CLASS_NAME } from 'modules/stores/store/constants/store-item-class-name';
import { useStorePreviewContext } from 'modules/stores/store/context/store-preview-context';
import { StoreInterface } from 'modules/stores/types/stores-interface';
import React, { FC, useEffect } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twJoin, twMerge } from 'tailwind-merge';
import PreviewBoxMobile from '../preview-box-mobile';
import { StoreThemeColorPicker } from './store-theme-color-picker';
import { StoreThemeSaveButton } from './store-theme-save-button';
import { CheckCircleIcon, SmallPenIcon } from '@systemeio/ui/icons';
interface StoreEditDesignProps {
  store: StoreInterface;
}
const StoreEditDesign: FC<StoreEditDesignProps> = t0 => {
  const $ = _c(42);
  const {
    store
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    setPreview,
    setSingleItemMode
  } = useStorePreviewContext();
  const {
    state,
    setState
  } = useDesignContext();
  let t1;
  let t2;
  if ($[0] !== setState || $[1] !== store.design) {
    t1 = () => {
      setState(store.design);
      return () => setState(store.design);
    };
    t2 = [setState, store.design];
    $[0] = setState;
    $[1] = store.design;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== setPreview || $[5] !== setSingleItemMode || $[6] !== store.id || $[7] !== store.items || $[8] !== store.profile || $[9] !== store.socialLinks) {
    t3 = () => {
      setPreview([<Home key={store.id} profile={store.profile} socialLinks={store.socialLinks} items={store.items.filter(_temp)} displayAffiliateLink={false} />]);
      setSingleItemMode(false);
    };
    $[4] = setPreview;
    $[5] = setSingleItemMode;
    $[6] = store.id;
    $[7] = store.items;
    $[8] = store.profile;
    $[9] = store.socialLinks;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== setPreview || $[12] !== setSingleItemMode || $[13] !== store) {
    t4 = [setPreview, setSingleItemMode, store];
    $[11] = setPreview;
    $[12] = setSingleItemMode;
    $[13] = store;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  useEffect(t3, t4);
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = twMerge(STORE_ITEM_CLASS_NAME, "flex flex-col gap-5");
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t) {
    t6 = t("dashboard.store.theme.select_theme");
    $[16] = t;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = Object.values(StoreThemeEnum);
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== setState || $[20] !== state) {
    t8 = <div className="grid w-full grid-cols-2 justify-items-center gap-5 xl:grid-cols-3">{t7.map(theme => {
        const isSelected = theme === state.theme;
        const defaultValue = defaultDesignValues[theme];
        return <button onClick={() => !isSelected && setState(defaultValue)} key={theme} className={twJoin("shadow-around-sm main-transition-colors relative aspect-[1/2] w-full max-w-[350px] overflow-y-hidden rounded-lg border outline-hidden", isSelected ? "border-brand-primary" : "border-text-secondary/30")}>{isSelected && <CheckCircleIcon className="fill-brand-primary absolute left-1 top-1" />}<img alt={theme} src={`${S3_BUCKET_URL}/images/theme-preview/${theme}-preview.png`} /></button>;
      })}</div>;
    $[19] = setState;
    $[20] = state;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t6 || $[23] !== t8) {
    t9 = <ItemSteps steps={[{
      key: "theme",
      title: t6,
      element: t8
    }]} />;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="hidden lg:block"><StoreThemeColorPicker /></div>;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="hidden lg:block"><StoreFontPicker /></div>;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t) {
    t12 = t("dashboard.store.theme.edit_theme");
    $[27] = t;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SmallPenIcon />;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12) {
    t14 = <PreviewBoxMobile title={t12} icon={t13} className="flex-1 sm:flex-initial" />;
    $[30] = t12;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t) {
    t15 = t("dashboard.store.theme.apply_theme");
    $[32] = t;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t15) {
    t16 = <StoreThemeSaveButton title={t15} className="w-fit flex-1 sm:flex-initial" />;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t14 || $[37] !== t16) {
    t17 = <div className="bg-background-secondary sticky bottom-0 -mb-5 -ml-5 box-content flex w-full flex-wrap items-end justify-between gap-x-5 gap-y-3 rounded-b-md p-5 sm:justify-end lg:justify-between">{t10}{t11}{t14}{t16}</div>;
    $[36] = t14;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t17 || $[40] !== t9) {
    t18 = <div className={t5}>{t9}{t17}</div>;
    $[39] = t17;
    $[40] = t9;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  return t18;
};
export default StoreEditDesign;
function _temp(el) {
  return !el.draft;
}